"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredicorBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
class CredicorBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.CREDICOR_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU03',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Gain 1 TR. Each opponent removes 3 plants.', (eb) => {
                            eb.empty().startAction.tr(1).nbsp().minus().plants(-3).digit.any;
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        game.automaBotVictoryPointsBreakdown.terraformRating++;
        const plantsToRemove = Math.min(player.plants, 3);
        player.deductResource(Resources_1.Resources.PLANTS, plantsToRemove, { log: true });
        game.log('${0} action: Gain 1 TR and remove up to 3 plants from each opponent', (b) => b.card(this));
        return undefined;
    }
}
exports.CredicorBot = CredicorBot;
//# sourceMappingURL=CredicorBot.js.map